import { createPinia, setActivePinia } from 'pinia';

import { defineAppPlugin } from '@/main';

// 參考 https://github.com/vuejs/pinia/blob/v2/packages/nuxt/src/runtime/plugin.vue3.ts
export default defineAppPlugin(({ app }) => {
  const pinia = createPinia();

  app.use(pinia);
  setActivePinia(pinia);
});
